var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 16.667H17.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.75 2.9162C14.0815 2.58468 14.5312 2.39844 15 2.39844C15.2321 2.39844 15.462 2.44416 15.6765 2.533C15.891 2.62184 16.0858 2.75205 16.25 2.9162C16.4142 3.08036 16.5444 3.27523 16.6332 3.48971C16.722 3.70418 16.7678 3.93406 16.7678 4.1662C16.7678 4.39835 16.722 4.62822 16.6332 4.8427C16.5444 5.05717 16.4142 5.25205 16.25 5.4162L5.83333 15.8329L2.5 16.6662L3.33333 13.3329L13.75 2.9162Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.befdc127f526edd3a451a2abbb261c11.svg";
export { ForwardRef as ReactComponent };